import { Service } from '@roc/feature-app-core';

// Column filters go as JSON, as in the leads dashboard
const toFiltersParam = (filters: Record<string, string>) =>
  filters && Object.keys(filters).length ? JSON.stringify(filters) : undefined;

const url = {
  OVERVIEW: '/api/v1/utility/emailSends/overview',
  CAMPAIGNS: '/api/v1/utility/emailSends/campaigns',
  CAMPAIGN: '/api/v1/utility/emailSends/campaign',
  CAMPAIGN_RECIPIENTS: '/api/v1/utility/emailSends/campaign/recipients',
  RECIPIENT_HISTORY: '/api/v1/utility/emailSends/recipientHistory',
  // Active originators and back office leads, the same list as Send Emails By Originator
  ORIGINATORS: '/api/v1/utility/sendgrid/getAllOwners',
};

// ownerEmail picks whose emails are shown ("all" for every sender): back office leads pick it in the outreach,
// marketing and back office leads in the marketing blasts
export class StatusDashboardService extends Service {

  getOverview(role: string, dateFrom: string, brand: string, ownerEmail: string) {
    return this.get(url.OVERVIEW, { role, dateFrom, brand, ownerEmail });
  }

  // filters: { name } filters by subject
  getCampaigns(
    role: string,
    dateFrom: string,
    brand: string,
    ownerEmail: string,
    filters: Record<string, string>,
    sortBy: string,
    sortDir: string,
    pageNumber: number,
    pageSize: number
  ) {
    return this.get(url.CAMPAIGNS, {
      role,
      dateFrom,
      brand,
      ownerEmail,
      filters: toFiltersParam(filters),
      sortBy,
      sortDir,
      pageNumber,
      pageSize,
    });
  }

  // groupKey is the campaign row of the overview, requested with the same filters
  getCampaign(role: string, groupKey: string, dateFrom: string, brand: string, ownerEmail: string) {
    return this.get(url.CAMPAIGN, { role, groupKey, dateFrom, brand, ownerEmail });
  }

  // filters: name and address are searched; sender, audience, opened, status and skipReason are the ticked values, comma
  // separated. sortBy is a column of the recipients table and sortDir ASC or DESC
  getCampaignRecipients(
    role: string,
    groupKey: string,
    dateFrom: string,
    brand: string,
    ownerEmail: string,
    filters: Record<string, string>,
    sortBy: string,
    sortDir: string,
    pageNumber: number,
    pageSize: number
  ) {
    return this.get(url.CAMPAIGN_RECIPIENTS, {
      role,
      groupKey,
      dateFrom,
      brand,
      ownerEmail,
      filters: toFiltersParam(filters),
      sortBy,
      sortDir,
      pageNumber,
      pageSize,
    });
  }

  getOriginators() {
    return this.get(url.ORIGINATORS);
  }

  getRecipientHistory(leadId: number, contactId: number, address: string) {
    return this.get(url.RECIPIENT_HISTORY, { leadId, contactId, address });
  }
}
